import { useTranslations } from "next-intl";

export type ContextTurn = { role: "user" | "agent"; text: string };

export function ContextTurns({ turns }: { turns: ContextTurn[] }) {
  const t = useTranslations("agentTests");
  return (
    <div
      data-testid="test-context"
      className="border rounded-lg p-4 flex flex-col gap-3 bg-muted/40"
    >
      {turns.map((turn, index) => (
        <div key={index} className="text-sm">
          <p className="text-xs text-muted-foreground">
            {turn.role === "user"
              ? t("checks.context.user")
              : t("checks.context.agent")}
          </p>
          <p className="whitespace-pre-line">{turn.text}</p>
        </div>
      ))}
    </div>
  );
}
